var star2 = "/static/2b834ecef1d2eb77.webp";

export { star2 as default };
//# sourceMappingURL=star-2.webp.js.map
